import { jsx, jsxs } from "react/jsx-runtime";
import { Modal, Box, Heading, Paragraph, Anchor, Button, CloseButton, Text, Icon } from "@zillow/constellation-10";
import { IconArrowRightOutline } from "@zillow/constellation-icons";
const PLATFORM_LINKS = {
  dotloop: "https://www.dotloop.com/#/signin",
  followUpBoss: "https://app.followupboss.com/login",
  premierAgent: "https://premieragent.zillow.com/crm/agentlogin/",
  support: "https://www.zillow.com/help/",
  workspace: "https://app.zillowpro.com"
};
function AgentLoginModal({
  title
}) {
  return /* @__PURE__ */ jsx(Modal, { scrollDocument: true, dividers: false, size: {
    base: "fullScreen",
    md: "sm"
  }, css: {
    '&:not(:has([data-c11n-component="Modal.Header"]))': {
      paddingBlockStart: "looser"
    }
  }, closeButton: /* @__PURE__ */ jsx(CloseButton, {}), trigger: /* @__PURE__ */ jsx(Button, { tone: "brand", emphasis: "outlined", size: "md", type: "button", children: title }), children: /* @__PURE__ */ jsx(Modal.Body, { children: /* @__PURE__ */ jsxs(Box, { css: {
    display: "flex",
    flexDirection: "column",
    paddingInline: "looser",
    paddingBlockEnd: "looser"
  }, children: [
    /* @__PURE__ */ jsx(Heading, { level: 4, css: {
      marginBottom: "default"
    }, children: "Sign In" }),
    /* @__PURE__ */ jsx(Paragraph, { css: {
      marginBottom: "looser"
    }, children: "Select which software you'd like to sign in to:" }),
    /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      flexDirection: "column",
      gap: "loose"
    }, children: [
      /* @__PURE__ */ jsx(AgentPlatformButton, { title: "Zillow Pro", description: "Access dotloop, Showcase & Zillow Media Experts", link: PLATFORM_LINKS.workspace }),
      /* @__PURE__ */ jsx(AgentPlatformButton, { title: "Premier Agent & Profiles", description: "Lead Generation & Profile Management", link: PLATFORM_LINKS.premierAgent }),
      /* @__PURE__ */ jsx(AgentPlatformButton, { title: "Follow Up Boss", description: "Real Estate CRM & Lead Management", link: PLATFORM_LINKS.followUpBoss }),
      /* @__PURE__ */ jsx(AgentPlatformButton, { title: "dotloop", description: "Real Estate Transaction Management", link: PLATFORM_LINKS.dotloop })
    ] }),
    /* @__PURE__ */ jsxs(Paragraph, { css: {
      marginTop: {
        base: "{spacing.1200}",
        md: "{spacing.800}"
      },
      textAlign: "center"
    }, children: [
      "Need help?",
      " ",
      /* @__PURE__ */ jsx(Anchor, { href: PLATFORM_LINKS.support, css: {
        fontWeight: "emphasis",
        _visited: {
          color: "text.link.default"
        }
      }, children: "Contact support" })
    ] })
  ] }) }) });
}
function AgentPlatformButton({
  description,
  link,
  title
}) {
  return /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    alignItems: "center",
    borderColor: "border.action.neutral.default",
    borderRadius: "400",
    borderStyle: "solid",
    borderWidth: "default",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBlock: "default",
    paddingInline: "loose",
    textDecoration: "none",
    transition: "background-color 200ms ease",
    width: "100%",
    _hover: {
      backgroundColor: "bg.action.neutral.hover"
    }
  }, children: /* @__PURE__ */ jsxs("a", { href: link, target: "_blank", rel: "noopener noreferrer", children: [
    /* @__PURE__ */ jsxs(Box, { css: {
      alignItems: "flex-start",
      display: "flex",
      flex: 1,
      flexDirection: "column"
    }, children: [
      /* @__PURE__ */ jsx(Text, { textStyle: "heading-xs", css: {
        marginBottom: "tightest"
      }, children: title }),
      /* @__PURE__ */ jsx(Text, { textStyle: "body-sm", children: description })
    ] }),
    /* @__PURE__ */ jsx(Box, { css: {
      alignItems: "center",
      backgroundColor: "bg.accent.brand.hero",
      borderRadius: "shape.ellipse",
      display: "flex",
      flexShrink: 0,
      height: "sizes.Icon.xl",
      justifyContent: "center",
      width: "sizes.Icon.xl"
    }, children: /* @__PURE__ */ jsx(Icon, { size: "xl", css: {
      color: "text.onImpact.neutral-fixed"
    }, children: /* @__PURE__ */ jsx(IconArrowRightOutline, {}) }) })
  ] }) });
}
export {
  AgentLoginModal as default
};
